import React, { useEffect, useState } from 'react';
export function ComingSoon() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set launch date: February 1, 2026
    const launchDate = new Date('2026-02-01T00:00:00').getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = launchDate - now;
      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative min-h-screen bg-black overflow-hidden flex items-center justify-center p-4" data-id="element-24">
      {/* Darker Galaxy-style static background */}
      <div className="absolute inset-0" data-id="element-25">
        {/* Deeper space gradient - much darker */}
        <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-950 to-black" data-id="element-26"></div>

        {/* Stars layer 1 - small stars, reduced opacity */}
        <div className="absolute inset-0 opacity-40" style={{
        backgroundImage: 'radial-gradient(2px 2px at 20% 30%, white, transparent), radial-gradient(2px 2px at 60% 70%, white, transparent), radial-gradient(1px 1px at 50% 50%, white, transparent), radial-gradient(1px 1px at 80% 10%, white, transparent), radial-gradient(2px 2px at 90% 60%, white, transparent), radial-gradient(1px 1px at 33% 80%, white, transparent), radial-gradient(1px 1px at 15% 90%, white, transparent)',
        backgroundSize: '200px 200px, 300px 300px, 150px 150px, 250px 250px, 180px 180px, 220px 220px, 280px 280px',
        backgroundPosition: '0 0, 40px 60px, 130px 270px, 70px 100px, 150px 50px, 250px 150px, 100px 200px'
      }} data-id="element-27"></div>

        {/* Stars layer 2 - medium stars, reduced opacity */}
        <div className="absolute inset-0 opacity-25" style={{
        backgroundImage: 'radial-gradient(3px 3px at 10% 20%, rgba(255,255,255,0.8), transparent), radial-gradient(2px 2px at 70% 40%, rgba(255,255,255,0.6), transparent), radial-gradient(2px 2px at 40% 90%, rgba(255,255,255,0.7), transparent), radial-gradient(3px 3px at 85% 80%, rgba(255,255,255,0.5), transparent)',
        backgroundSize: '400px 400px, 350px 350px, 300px 300px, 450px 450px',
        backgroundPosition: '50px 50px, 180px 200px, 300px 100px, 20px 300px'
      }} data-id="element-28"></div>

        {/* Nebula effect - darker, more subtle green clouds */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-emerald-950/15 rounded-full filter blur-[100px]" data-id="element-29"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-950/10 rounded-full filter blur-[120px]" data-id="element-30"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-green-950/8 rounded-full filter blur-[150px]" data-id="element-31"></div>

        {/* Additional deep space vignette */}
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/30 to-black/60" data-id="element-32"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center" data-id="element-33">
        {/* Logo - Bigger */}
        <div className="mb-10 md:mb-14 flex justify-center px-4" data-id="element-34">
          <img src="https://cdn.magicpatterns.com/uploads/rKga9pAi8adpMKwWSfNjdY/Asset_11x.png" alt="Brixen Funding" className="h-12 md:h-16 lg:h-20 w-auto" data-id="element-35" />
        </div>

        {/* Date */}
        <div className="mb-12 md:mb-16 px-4" data-id="element-36">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white tracking-wider" data-id="element-37">
            01.02.2026
          </h1>
        </div>

        {/* Digital Clock Countdown */}
        <div className="mb-12 md:mb-16 px-4" data-id="element-38">
          <div className="inline-flex items-center justify-center gap-3 sm:gap-4 md:gap-6 w-full max-w-full" data-id="element-39">
            {/* Days */}
            <div className="flex flex-col items-center min-w-0" data-id="element-40">
              <div className="relative" data-id="element-41">
                <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-42">
                  {String(timeLeft.days).padStart(2, '0')}
                </div>
                <div className="absolute inset-0 text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-[#00E676] blur-lg opacity-60 tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-43">
                  {String(timeLeft.days).padStart(2, '0')}
                </div>
              </div>
              <div className="text-xs sm:text-sm text-gray-500 uppercase tracking-widest mt-2 md:mt-3" data-id="element-44">
                Días
              </div>
            </div>

            {/* Separator */}
            <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#00E676] animate-pulse pb-6 md:pb-8" data-id="element-45">
              :
            </div>

            {/* Hours */}
            <div className="flex flex-col items-center min-w-0" data-id="element-46">
              <div className="relative" data-id="element-47">
                <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-48">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <div className="absolute inset-0 text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-[#00E676] blur-lg opacity-60 tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-49">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
              </div>
              <div className="text-xs sm:text-sm text-gray-500 uppercase tracking-widest mt-2 md:mt-3" data-id="element-50">
                Horas
              </div>
            </div>

            {/* Separator */}
            <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#00E676] animate-pulse pb-6 md:pb-8" data-id="element-51">
              :
            </div>

            {/* Minutes */}
            <div className="flex flex-col items-center min-w-0" data-id="element-52">
              <div className="relative" data-id="element-53">
                <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-54">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <div className="absolute inset-0 text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-[#00E676] blur-lg opacity-60 tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-55">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
              </div>
              <div className="text-xs sm:text-sm text-gray-500 uppercase tracking-widest mt-2 md:mt-3" data-id="element-56">
                Min
              </div>
            </div>

            {/* Separator */}
            <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#00E676] animate-pulse pb-6 md:pb-8" data-id="element-57">
              :
            </div>

            {/* Seconds */}
            <div className="flex flex-col items-center min-w-0" data-id="element-58">
              <div className="relative" data-id="element-59">
                <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-60">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <div className="absolute inset-0 text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-[#00E676] blur-lg opacity-60 tabular-nums tracking-tighter" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-61">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
              </div>
              <div className="text-xs sm:text-sm text-gray-500 uppercase tracking-widest mt-2 md:mt-3" data-id="element-62">
                Seg
              </div>
            </div>
          </div>
        </div>

        {/* Tagline */}
        <div className="space-y-4 md:space-y-6 px-4" data-id="element-63">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light text-white italic" data-id="element-64">
            La era Brixen está por comenzar...
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 font-medium" data-id="element-65">
            Financiamiento Comercial Accesible para Todos
          </p>
          <p className="text-sm sm:text-base md:text-lg text-gray-400" data-id="element-66">
            Algo grande viene en camino.
          </p>
        </div>
      </div>
    </div>;
}